import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DomUtilsService {

  aguardarElementoClique(elementId: string, tentativas: number, intervalo: number): void {
    let tentativasRestantes = tentativas;

    const interval = setInterval(() => {
      const elemento = document.getElementById(elementId) as HTMLLinkElement;

      if (elemento) {
        elemento.click();
        clearInterval(interval);
      } else {
        tentativasRestantes--;
        if (tentativasRestantes === 0) {
          clearInterval(interval);
        }
      }
    }, intervalo);
  }
}